/* Mercusoft theme additions */
/* Crest finder, ring options, wedding band builder */

var crestsLoaded = false;
const Drawer = window.customElements.get("x-drawer");
class CrestDrawer extends Drawer
{
    rootImageUrl = "http://www.myfamilysilver.com/img/crests/medium/";
    crests = [];
    nores;
    root;
    input;
    resultsArea;
    template;

    // Once the crest data is loaded, we should hide the loading text and show the searchbar and results
    Loaded() {
        for(const crest of window.FamilyCrests)
        {
            for(const familyName of crest[0]) {
                this.crests.push({name: familyName, crest: this.rootImageUrl + crest[1]});
            }
        }
        this.crests.sort((a,b) => a.name.localeCompare(b.name));

        this.querySelector("#loading").remove();

        this.nores = this.querySelector("#nores");
        this.root = this.querySelector(".Mercusoft__CrestFinder"); 
        this.input = this.querySelector("input");
        this.resultsArea = this.querySelector(".Mercusoft__CrestFinder__SearchResults");
        this.template = this.querySelector(".Mercusoft__CrestFinder__SearchResults > li").cloneNode(true);
        this.template.classList.remove("hidden");
        this.resultsArea.innerHTML = "";
        this.root.classList.remove("hidden");

        this.querySelector("form").addEventListener("submit", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.Search();
        });
    }
    
    Search()
    {
        let text = this.input.value.toLocaleLowerCase().trim();
        this.resultsArea.innerHTML = "";

        if (text.length < 3)
        {
            this.nores.classList.remove("hidden");
            return;
        }
        
        // Filter and display search results
        let found = false;
        for(const crest of this.crests)
        {
            if (!crest.name.toLocaleLowerCase().includes(text)) continue;
            found = true;
            this.CreateSearchResult(crest);
        }

        if (found) this.nores.classList.add("hidden");
        else this.nores.classList.remove("hidden");
    

    }

    CrestSelected(crest)
    {
        document.dispatchEvent(new CustomEvent("crests:selected", {detail: crest}));
        document.dispatchEvent(new CustomEvent("crests:close"));
        this.hide();
    }

    CreateSearchResult(crest)
    {
        let newResult = this.template.cloneNode(true);
        newResult.querySelector("span").innerText = crest.name;
        newResult.querySelector("img").src = crest.crest;
        let select = this.CrestSelected;
        newResult.querySelector("button").addEventListener("click", function() {
            select(crest);
        });
        this.resultsArea.append(newResult);
    }

    constructor() {
        super(...arguments);
        this.Loaded = this.Loaded.bind(this);
        this.Search = this.Search.bind(this);
        this.CrestSelected = this.CrestSelected.bind(this);
        this.CreateSearchResult = this.CreateSearchResult.bind(this);
    }
    connectedCallback()
    {
        super.connectedCallback();
        if (crestsLoaded) this.Loaded();
        else window.addEventListener("crests:loaded", this.Loaded);
    }
}
window.customElements.define("crest-drawer", CrestDrawer);



(function(){
    function CrestsLoaded() {
        console.log("LOAD");
        crestsLoaded = true;
        window.removeEventListener("crests:loaded", CrestsLoaded);
    }
    window.addEventListener("crests:loaded", CrestsLoaded)

    // Initialize custom elements when page has loaded
    document.addEventListener("DOMContentLoaded", function(){
        IntializeRingOptions();
    });

    function IntializeRingOptions(){
        var ringOptionDynamicVariants = {};

        var prevItems = [];
        function updateAddons()
        {
            var map = {
                "_InscriptionProduct": ["Inscription"],
                "_EngravingInitialsProduct": ["Initials"],
                "_EngravingSealProduct": ["Engraving (File)", "Engraving (Family Crest)"]
            }
            // get cart
            fetch('/cart.js', {
                method: "GET",
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function(v) {
                return v.json();
            }).then(function(json) {
                let updates = {};
                // reset all ring options addons to 0
                for(let item of (prevItems.length ? prevItems : json.items)) {
                    for(let k in map)
                    {
                        for(let field of map[k])
                        {
                            if (item.properties && item.properties[k] && item.properties[field])
                            {
                                updates[item.properties[k]] = 0;
                            }
                        }
                    }
                }
                // add ring options addons
                for(let item of json.items) {
                    for(let k in map)
                    {
                        for(let field of map[k])
                        {
                            if (item.properties && item.properties[k] && item.properties[field])
                            {
                                updates[item.properties[k]] += 1;
                            }
                        }
                    }
                }
                prevItems = json.items;
                fetch("/cart/update.js", {
                    method: "POST",
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: Object.keys(updates).map(k => "updates[" + k + "]=" + updates[k]).join("&"),
                }).then(function(res) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                });
            });
        }

        function setPriceSpanText(price)
        {
            const buyButton = document.querySelector("buy-buttons.buy-buttons");
            if (!buyButton) return;
            const moneySpan = buyButton.querySelector(".money");
            moneySpan.innerText = formatMoney(price);
        }

        function hideElement(elem)
        {
            elem.classList.add("hidden");
        }
    
        function showElement(elem)
        {
            elem.classList.remove("hidden");
        }
    
        function formatMoney(amt)
        {
            return Intl.NumberFormat("en-US", { style: 'currency', currency: Shopify.currency.active}).format(amt * (+Shopify.currency.rate));
        }
    
        function updatePrice()
        {
            var price = +basePrice;
            var inputs = [
                engravingInput,
                crestInput,
                initialsInput,
                inscriptionInput
            ]
            for(let input of inputs)
            {
                if (input && input.value && input.value != "") price += +input.dataset.price;
            }
            setPriceSpanText(price);
        }

        // Update the cart addons when the theme loads or the page unloads
        document.addEventListener("theme:loading:end", updateAddons);
        window.onbeforeunload = updateAddons;
        
        let basePrice = +window.mercusoftProductBasePrice;
        delete window.mercusoftProductBasePrice;
    
        // Seal Engraving elements
        const engravingFieldset = document.getElementById("mercusoft-engraving-fieldset");
        const engravingInput = document.getElementById("mercusoft-engraving");
        const crestInput = document.getElementById("mercusoft-engraving-crest"); // hidden input which represents the image URL of a family crest (if selected)
        const img = document.getElementById("mercusoft-engraving-preview");
        const crestButton = document.getElementById("mercusoft-engraving-crest-finder");
        const clearButton = document.getElementById("mercusoft-engraving-clear");

        // Initials Engraving elements
        const initialsFieldset = document.getElementById("mercusoft-engraving-initials-fieldset");
        const initialsInput = document.getElementById("mercusoft-engraving-initials");
        const nagRadios = document.querySelectorAll("input[type=radio][id^=mercusoft-engraving-initials-opt]");

        // This form has the engraving options
        if (engravingInput && crestInput && img && crestButton && clearButton && initialsInput) {
            clearButton.onclick = clearField;

            document.addEventListener("crests:selected", function(e) {
                const crest = e.detail;
                setImage(crest.crest);
            });
        
            engravingInput.addEventListener("change", function(e){
                const file = e.target.files[0];
                if (file)
                {
                    let reader = new FileReader();
                    reader.onload = function(event) {
                        setImage(event.target.result);
                        crestInput.value = null;
                        updatePrice();
                    }
                    reader.readAsDataURL(file);
                } else {
                    clearField();
                }
            });

            nagRadios.forEach(r => r.addEventListener("change", function(e) {
                e.stopPropagation(); // prevent theme default functionality treating these radios as default product options
            }));

            initialsInput.addEventListener("change", function(e) {
                engravingFieldset.disabled = e.target.value != "";
                if (e.target.value)
                {
                    clearField();
                    for(let radio of nagRadios)
                    {
                        if (radio.checked) return;
                    }
                    nagRadios[0].checked = true;
                } else {
                    clearInitials();
                }
                updatePrice();
            });
    
            function clearField()
            {
                img.src = "";
                hideElement(img);
                hideElement(clearButton);
                initialsFieldset.disabled = false;
                crestInput.value = "";
                engravingInput.value = "";
                updatePrice();
            }
        
            function clearInitials()
            {
                initialsInput.value = "";
                nagRadios.forEach(r => r.checked = false);
            }
        
            function setImage(src)
            {
                img.src = src;
                crestInput.value = src;
                showElement(img);
                showElement(clearButton);
                initialsFieldset.disabled = true;
                clearInitials();
                updatePrice();
            }
        }

        // Inscription input
        const inscriptionInput = document.getElementById("mercusoft-inscription");
        if (inscriptionInput) inscriptionInput.addEventListener("change", updatePrice);

        document.addEventListener('variant:changed', function(event) {
            basePrice = (+event.detail.variant.price) / 100;
            updatePrice();
        });
    
        updatePrice();
        updateAddons();
    }
})();